@if (snackbar) {
  <div class="snackbar-container">
    <div class="snackbar">
      <i [ngClass]="['icon fa-light', snackbar.level, iconLevel()]"></i>
      <div class="snackbar-value">
        <span class="snackbar-label">{{ snackbar.title | translate:snackbar?.messageVariables }}</span>
        @if (snackbar.description) {
          <span
          class="snackbar-description">{{ snackbar.description | translate:snackbar?.messageVariables }}</span>
        }
        @if (snackbar.link) {
          <a [href]="snackbar.link.url">{{ snackbar.link.label }}</a>
        }
      </div>
      <i class="close-snackbar fa-sharp fa-light fa-xmark" (click)="closeSnackbar()"></i>
    </div>
  </div>
}
